import { PaymentHistoryType } from 'models/payment.model';

export const DUMMY_DATA: PaymentHistoryType[] = [
  {
    amountPaid: 2342,
    datePaid: '2022-03-22',
    id: 'aSvs',
    notes: '',
    partner: {
      name: 'Tames brown'
    },
    tripRevenue: 32312
  },
  {
    amountPaid: 2342,
    datePaid: '2022-03-22',
    id: 'aSvaergs',
    notes: '',
    partner: {
      name: 'James brown'
    },
    tripRevenue: 32312
  },
  {
    amountPaid: 2342,
    datePaid: '2022-03-22',
    id: 'aShrvs',
    notes: '',
    partner: {
      name: 'James brown'
    },
    tripRevenue: 32312
  }
];
